function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#FFEDEE"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 17.2V20m0 2.8h.007M27 20a7 7 0 11-14 0 7 7 0 0114 0z",
  stroke: "#D92D20",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgIconAimateAlert = function SvgIconAimateAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiNGRkVERUUiLz4KPHBhdGggZD0iTTIwIDE3LjJWMjBNMjAgMjIuOEgyMC4wMDdNMjcgMjBDMjcgMjMuODY2IDIzLjg2NiAyNyAyMCAyN0MxNi4xMzQgMjcgMTMgMjMuODY2IDEzIDIwQzEzIDE2LjEzNCAxNi4xMzQgMTMgMjAgMTNDMjMuODY2IDEzIDI3IDE2LjEzNCAyNyAyMFoiIHN0cm9rZT0iI0Q5MkQyMCIgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgIconAimateAlert as ReactComponent };